import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import cuid from 'cuid';
import { Box } from '../Box/index.js';
import { hiddenVisuallyCSS } from '../HiddenVisually/index.js';
import { useTheme } from '../hooks/useTheme.js';
import { RadioSvg } from './RadioSvg.js';

var RadioInput = forwardRef(function (props, ref) {
    var _a = props.id, id = _a === void 0 ? cuid() : _a, _b = props.size, size = _b === void 0 ? "md" : _b, sx = props.sx, inputProps = __rest(props, ["id", "size", "sx"]);
    var theme = useTheme().theme;
    var variants = theme.components.radioSvg.variants;
    return (jsxs(Box, __assign({ sx: __assign({ position: "relative", lineHeight: 1, "input[type=radio]:disabled + svg": variants === null || variants === void 0 ? void 0 : variants.isDisabled.true, "input[type=radio]:checked + svg": variants === null || variants === void 0 ? void 0 : variants.isChecked.true, "input[type=radio]:focus + svg": variants === null || variants === void 0 ? void 0 : variants.isFocused.true }, sx) }, { children: [jsx("input", __assign({ id: id, ref: ref, type: "radio", style: hiddenVisuallyCSS }, inputProps)), jsx(RadioSvg, { size: size, id: id ? "".concat(id, "-svg") : undefined })] })));
});
RadioInput.displayName = "RadioInput";

export { RadioInput };
//# sourceMappingURL=RadioInput.js.map
